import React, { useEffect, useState } from 'react';
import Link from '../vida-link';

const VidaSidebar: React.FC = () => {
  const [currentHash, setCurrentHash] = useState('');

  useEffect(() => {
    function updateHash() {
      const hash = window.location.hash;
      setCurrentHash(hash);
    }

    // Run when the page is loaded
    updateHash();
    // Run when hash changes (hash changes dont cause force-reload)
    window.addEventListener('hashchange', updateHash);
    // Cleanup
    return () => window.removeEventListener('hashchange', updateHash);
  }, []);

  return (
    <div className="vida-sidebar">
      <div className="sidebar-group">
        <h3>
          <Link href="/vida" hash={currentHash}>
            <a>VIDA</a>
          </Link>
        </h3>
        <ul>
          <li>
            <Link
              href="/vida#diagnostic-tools"
              activeClass="active"
              hash={currentHash}
            >
              <a>Diagnostic Tools</a>
            </Link>
          </li>
          <li>
            <Link
              href="/vida#volvotechinfo-com-website"
              activeClass="active"
              hash={currentHash}
            >
              <a>Volvotechinfo.com Website</a>
            </Link>
          </li>
          <li>
            <Link
              href="/vida#purchasing-a-vida-subscription"
              activeClass="active"
              hash={currentHash}
            >
              <a>Purchasing a VIDA Subscription</a>
            </Link>
          </li>
          <li>
            <Link
              href="/vida#vida-install-link"
              activeClass="active"
              hash={currentHash}
            >
              <a>VIDA Install Link</a>
            </Link>
          </li>
          <li>
            <Link
              href="/vida#installing-vida-and-vida-admin-setup"
              activeClass="active"
              hash={currentHash}
            >
              <a>Installing VIDA and VIDA Admin Setup</a>
            </Link>
          </li>
          <li>
            <Link
              href="/vida#workshop-literature-library"
              activeClass="active"
              hash={currentHash}
            >
              <a>Workshop Literature Library</a>
            </Link>
          </li>
          <li>
            <Link href="/vida#idm" activeClass="active" hash={currentHash}>
              <a>VIDA User IDs</a>
            </Link>
          </li>
          <li>
            <Link
              href="/vida#using-the-vida-system"
              activeClass="active"
              hash={currentHash}
            >
              <a>Using the VIDA System</a>
            </Link>
          </li>
          <li>
            <Link
              href="/vida#ordering-software"
              activeClass="active"
              hash={currentHash}
            >
              <a>Ordering Software</a>
            </Link>
          </li>
          <li>
            <Link href="/vida#notices" activeClass="active" hash={currentHash}>
              <a>CCPA/GDPR Information Notices</a>
            </Link>
          </li>
          <li>
            <Link
              href="/vida#entra-password-reset"
              activeClass="active"
              hash={currentHash}
            >
              <a>ENTRA ID Password Reset (formerly Azure)</a>
            </Link>
          </li>
          <li>
            <Link
              href="/vida#refund-policies"
              activeClass="active"
              hash={currentHash}
            >
              <a>Subscription/Software Refund Policies</a>
            </Link>
          </li>
        </ul>
      </div>
      <div className="sidebar-group">
        <h3>
          <Link
            href="/vida/ir-workshop-instructional-library"
            hash={currentHash}
          >
            <a>IR Workshop Instructional Library</a>
          </Link>
        </h3>
        <ul />
      </div>
      <div className="sidebar-group">
        <h3>
          <Link href="https://www.volvospecialtools.com/" hash={currentHash}>
            Special Tools
          </Link>
        </h3>
        <ul />
      </div>
      <div className="sidebar-group">
        <h3>
          <Link
            href="https://vidaresources.volvocars.biz/vidaeula/VIDA_License_Agreement_en_US.pdf"
            hash={currentHash}
          >
            VIDA License Agreement
          </Link>
        </h3>
        <ul>
          <li>
            <Link
              href="https://vidaresources.volvocars.biz/vidaeula/VIDA_License_Agreement_en_US.pdf"
              hash={currentHash}
            >
              English
            </Link>
          </li>
          <li>
            <Link
              href="https://vidaresources.volvocars.biz/vidaeula/VIDA_License_Agreement_fr_FR.pdf"
              hash={currentHash}
            >
              French
            </Link>
          </li>
          <li>
            <Link
              href="https://vidaresources.volvocars.biz/vidaeula/VIDA_License_Agreement_es_ES.pdf"
              hash={currentHash}
            >
              Spanish
            </Link>
          </li>
        </ul>
      </div>
      <div className="sidebar-group">
        <h3>
          <Link href="/vida/computer-requirements" hash={currentHash}>
            <a>Computer Requirements</a>
          </Link>
        </h3>
        <ul />
      </div>
      <div className="sidebar-group">
        <h3>
          <Link href="/vida/purchase" hash={currentHash}>
            <a>Purchase</a>
          </Link>
        </h3>
        <ul>
          <li>
            <Link
              href="/vida/purchase#vida-subscriptions-and-pricing"
              activeClass="active"
              hash={currentHash}
            >
              <a>VIDA Subscriptions and Pricing</a>
            </Link>
          </li>
          <li>
            <Link
              href="/vida/purchase#purchase-vida-subscription"
              activeClass="active"
              hash={currentHash}
            >
              <a>Purchase VIDA and Bulletin Subscriptions</a>
            </Link>
          </li>
        </ul>
      </div>
      <div className="sidebar-group">
        <h3>
          <Link href="/knowledgebase" hash={currentHash}>
            <a>Support</a>
          </Link>
        </h3>
        <ul />
      </div>
      {/* language=CSS */}
      <style jsx>{`
        .vida-sidebar {
          padding: 3rem 3rem;
          position: fixed;
          font-family: 'Volvo Novum', sans-serif;
        }

        h3 {
          margin: 0;
        }

        .sidebar-group h3 :global(a) {
          color: var(--text-primary);
          text-decoration: none;
          transition: all 200ms ease-in-out;
          font-weight: 500;
        }

        .sidebar-group h3 :global(a:hover) {
          color: var(--interactive-primary);
        }

        ul {
          margin: 1rem 0 1rem;
          list-style: none;
        }

        ul li a,
        ul li :global(a) {
          color: var(--text-primary);
          text-decoration: none;
          transition: all 200ms ease-in-out;
          font-weight: 400;
          font-size: 14px;
        }

        ul li a:hover,
        ul li :global(a:hover) {
          color: var(--interactive-primary);
        }

        ul li a.active {
          color: var(--interactive-primary);
          font-weight: 500;
        }

        @media screen and (max-width: 1350px) {
          .vida-sidebar {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
          }

          .sidebar-group ul {
            padding: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default VidaSidebar;
